import { render, staticRenderFns } from "./Resolutions.vue?vue&type=template&id=3196a29c"
import script from "./Resolutions.vue?vue&type=script&lang=js"
export * from "./Resolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports